export default __webpack_public_path__ + "20c0f9aeeb172cae275fcbb582609c3e.jpg";